module.exports = __webpack_public_path__ + "img/bg.1cf2bd9c.jpeg";